<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false" normal-width="90vw" width="1120px">

    <img :src="isSummer ? SITE_CONFIG.skischool.map_summer : SITE_CONFIG.skischool.map" />

  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  data() {
    return {
      maxTop: 165,
      maxRight: 256,
      zoom: 2,
    };
  },
  mounted() {
  },
  computed: {
    isSummer() {
      return this.$route.name === 'bike school overview';
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
    ]),
  },
  filters: {
  },
};
</script>

<style lang="stylus">
@import "~leaflet/dist/leaflet.css"
</style>



// WEBPACK FOOTER //
// SkiSchoolLocationMap.vue?4b387fff